import React from 'react';
import { Upload, Loader2 } from 'lucide-react';

/**
 * Zona di upload PDF con dropzone.
 * Bloccata se i campi obbligatori non sono compilati.
 * @param {Object} props
 * @param {boolean} props.isConfigComplete - true se lead, tipo e target sono compilati
 * @param {boolean} props.uploading
 * @param {Object} props.dropzone - oggetto restituito da useDropzone
 */
export const UploadZone = ({ isConfigComplete, uploading, dropzone }) => {
  const { getRootProps, getInputProps, isDragActive, open } = dropzone;

  return (
    <div className="el-card p-6">
      <h2 className="text-xl font-medium text-[#1B291B] mb-1">4. Carica Bollette (in formato .pdf)</h2>
      <p className="text-xs text-red-600 mb-4 italic underline">*Si sconsiglia di caricare fotografie o scansioni poco leggibili</p>

      {!isConfigComplete ? (
        <div className="el-upload-zone opacity-50 cursor-not-allowed" data-testid="upload-zone-disabled">
          <Upload className="w-12 h-12 text-[#5C6E5C]" />
          <p className="mt-4 text-[#5C6E5C] font-medium text-center">
            Prima compila tutti i campi obbligatori
          </p>
        </div>
      ) : (
        <div
          {...getRootProps()}
          className={`el-upload-zone ${isDragActive ? 'dragging' : ''}`}
          data-testid="upload-zone"
        >
          <input {...getInputProps()} data-testid="file-input" />
          {uploading ? (
            <div className="flex flex-col items-center">
              <Loader2 className="w-12 h-12 text-[#4CAF50] animate-spin" />
              <p className="mt-4 text-[#5C6E5C]">Caricamento e analisi in corso...</p>
            </div>
          ) : (
            <>
              <Upload className="w-12 h-12 text-[#4CAF50]" />
              <p className="mt-4 text-[#1B291B] font-medium">
                {isDragActive ? 'Rilascia i file qui' : 'Trascina le bollette PDF qui'}
              </p>
              <p className="mt-2 text-sm text-[#5C6E5C]">oppure clicca per selezionare</p>
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); open(); }}
                className="mt-4 el-btn-primary text-sm py-2 px-4"
                data-testid="select-files-btn"
              >
                Seleziona File PDF
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};
